// src/utils/roles.ts
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  DEVELOPER: 'developer',
  MAINTAINER: 'maintainer',
  ACCOUNT_MANAGER: 'account_manager',
  CLIENT: 'client',
};
// src/utils/permissions.ts
export const PERMISSIONS_LIST = {
  // Dashboard
  VIEW_DASHBOARD: 'view-dashboard',
  VIEW_DASHBOARD_METRICS: 'view-dashboard-metrics',
  VIEW_TODO_TASKS: 'view-todo-tasks',
  CREATE_TODO_TASKS: 'create-todo-tasks',
  UPDATE_TODO_TASK_STATUS: 'update-todo-task-status',
  VIEW_ANALYTICS: 'view-analytics',

  // Content Management
  VIEW_CONTENT: 'view-content',
  CREATE_CONTENT: 'create-content',
  PUBLISH_CONTENT: 'publish-content',
  SAVE_DRAFT: 'save-draft',
  EDIT_CONTENT: 'edit-content',
  DELETE_CONTENT: 'delete-content',

  // Template Management
  VIEW_TEMPLATES: 'view-templates',
  CREATE_TEMPLATES: 'create-templates',
  EDIT_TEMPLATES: 'edit-templates',
  DELETE_TEMPLATES: 'delete-templates',

  // Asset Management
  VIEW_ASSETS: 'view-assets',
  UPLOAD_ASSETS: 'upload-assets',
  DELETE_ASSETS: 'delete-assets',

  // Library Management
  VIEW_LIBRARY: 'view-library',
  UPDATE_LIBRARY: 'update-library',
  DELETE_LIBRARY: 'delete-library',

  // Attribute Management
  VIEW_ATTRIBUTES: 'view-attributes', 
  CREATE_ATTRIBUTE_SETS: 'create-attribute-sets',
  DELETE_ATTRIBUTE_SETS: 'delete-attribute-sets',
  CREATE_ATTRIBUTES: 'create-attributes',
  UPDATE_ATTRIBUTES: 'update-attributes',
  DELETE_ATTRIBUTES: 'delete-attributes',

  // Profile & Settings
  VIEW_PROFILE: 'view-profile',
  EDIT_PROFILE: 'edit-profile',
  CHANGE_PASSWORD: 'change-password',
  ENABLE_2FA: 'enable-2fa',
  VIEW_SETTINGS: 'view-settings',
  UPDATE_SETTINGS: 'update-settings',
  VIEW_BILLING: 'view-billing',

  // General settings
  VIEW_GENERAL_SETTINGS: 'view-general-settings',
  UPDATE_GENERAL_SETTINGS: 'update-general-settings',

  // Team Management
  VIEW_TEAM: 'view-team',
  ADD_TEAM: 'add-team',
  UPDATE_TEAM: 'update-team',
  REMOVE_TEAM: 'remove-team',

  // API Token Management
  VIEW_TOKEN: 'view-token',
  GENERATE_TOKEN: 'generate-token',
  REVOKE_TOKEN: 'revoke-token',

  // Help & Support
  VIEW_HELP_GUIDE: 'view-help-guide',
  VIEW_SUPPORT: 'view-support',
  VIEW_TICKETS: 'view-tickets',
  CREATE_TICKETS: 'create-tickets',

  // ROLE MANAGEMENT
  VIEW_ROLES: 'view-roles',
  CREATE_ROLES: 'create-roles',
  UPDATE_ROLES: 'update-roles',
  DELETE_ROLES: 'delete-roles',

  // ACTIVITY LOGS
  VIEW_ACTIVITY_LOGS: 'view-activity-logs',
  ACTIVITY_LOGS_TEAM: 'activity-logs-team',

  // SUBSCRIPTION MANAGEMENT
  VIEW_SUBSCRIPTION: 'view-subscription',
  UPDATE_SUBSCRIPTION: 'update-subscription',
} as const;